import styles from './PaymentsDetailsSection.module.scss';

import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeRight } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';

import ImgPeopleMonitoring from 'src/images/img-people-monitoring.png';
import ImgPeopleMonitoring2x from 'src/images/img-people-monitoring@2x.png';
import ImgPeopleMonitoring3x from 'src/images/img-people-monitoring@3x.png';

export default (props) => (
  <div styleName='payments-details-section'>
      <Container>
          <div styleName='text-container'>
              <div className='h2'>
                  They say you can&rsquo;t have it all
              </div>
              <div className='h2 text-blue'>
                  Fortunately, they&rsquo;re wrong.
              </div>
              <div styleName='features-table'>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Improve cash flow</div>
                      <div>
                          Don’t pay until you have to. Galleon times payments to
                          take full advantage of your carriers’ terms. You may
                          also qualify for extended financing terms.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Simplify bookkeeping</div>
                      <div>
                          Keep it simple. Instead of reconciling scores of
                          invoices, Galleon will send you a single CSV &mdash; with
                          accruals and GL coding already done &mdash; ready for
                          direct upload into your books.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Save more</div>
                      <div>
                          Get Galleon for cheap or free. Payments customers are
                          eligible for deeply discounted or even waived fees on
                          other Galleon services.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Ready to learn more?</div>
                      <div>
                          <ButtonLink to='contact' className='mt-2'>
                              Contact us
                          </ButtonLink>
                      </div>
                  </div>
              </div>
          </div>
      </Container>
      <div styleName='splash-image-container'>
          <RetinaImage srcSet={[ImgPeopleMonitoring, ImgPeopleMonitoring2x, ImgPeopleMonitoring3x]}
                       styleName='splash-image' />
      </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/PaymentsDetailsSection.js